import { Component, OnInit, ViewChild } from '@angular/core';

import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { Connection, ConnectionService } from 'src/app/services/connection.service';

interface loginReply {
  message: string;
  token?: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public connection_name: string = "Autopilot";
  public server: string = "https://server.g72.com.au";
  public password: string = "";

  public tryAgain = 0;

  public connectionFailed = false;

  public select_connection_name = "internal";

  constructor(
    private authService: AuthService,
    private router: Router,
    private navigationService: NavigationService,
    public connectionService: ConnectionService
    ) {}


  ngOnInit(): void {

  }

  login() {
    this.connectionFailed = false;
    
    this.authService.authenticate(this.server, this.password).subscribe((reply: loginReply)  => {

      if (reply.message == "DENIED") {
        this.tryAgain++;
      } else if (reply.message == "ACCEPTED") {
        localStorage.setItem('token', reply.token)

        let connection = {
          name: this.connection_name,
          address: this.server,
          token: reply.token
        };

        this.connectionService.addConnection(connection);
        this.connectionService.switchTo(connection);

        window.location.reload()
      }

    }, (error: any) => {
      this.connectionFailed = true;
    });
  }

  switchTo(connection: Connection) {
    this.connectionService.switchTo(connection);
    this.router.navigate["/dashboard"].then(() => {
      window.location.reload();
    })
  }

  deleteConnection (connection: Connection) {
    this.connectionService.deleteConnection(connection)
  }
}